var ProductReviews, paginationFooter;

ProductReviews = window.ProductReviews != null ? window.ProductReviews : window.ProductReviews = {};

if (ProductReviews.Views == null) {
  ProductReviews.Views = {};
}

if (ProductReviews.Templates == null) {
  ProductReviews.Templates = {};
}

paginationFooter = require('../../common/pagination_helpers').paginationFooter;

ProductReviews.Templates['product_reviews_pagination_footer'] = require('../../pagination_footer.html.mustache');

ProductReviews.Views.PaginationFooter = Backbone.View.extend({
  el: '#product-reviews-pagination-footer',
  template: ProductReviews.Templates['product_reviews_pagination_footer'],
  initialize: function() {
    return this.listenTo(this.collection, 'request error', this.reset);
  },
  reset: function() {
    this.updateFooter();
    return this.render();
  },
  updateFooter: function() {
    var page, pageSize, ref, reviewCount;
    reviewCount = this.options.reviewCount;
    ref = this.collection, page = ref.page, pageSize = ref.pageSize;
    return this.footer = paginationFooter(page, reviewCount.value, pageSize, I18n);
  },
  render: function() {
    return this.$el.html(this.template.render({
      paginationFooter: this.footer
    }));
  }
});

module.exports = ProductReviews.Views.PaginationFooter;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWtlc2hhcmkvbmFwaXN0cmFuby9idWlsZC8xNDk1NjYwODk4MjQ5LTQzOTYvcHJvZHVjdGlvbi0yMDE3LjA1LjI0XzIxLjE5L2RlYWwvbW9kdWxlcy9wcm9kdWN0X3Jldmlld3MvZnJvbnRlbmQvdmlld3MvcGFnaW5hdGlvbl9mb290ZXIuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3Zhci9ncm91cG9uL2hvbWUvYWtlc2hhcmkvbmFwaXN0cmFuby9idWlsZC8xNDk1NjYwODk4MjQ5LTQzOTYvcHJvZHVjdGlvbi0yMDE3LjA1LjI0XzIxLjE5L2RlYWwvbW9kdWxlcy9wcm9kdWN0X3Jldmlld3MvZnJvbnRlbmQvdmlld3MvcGFnaW5hdGlvbl9mb290ZXIuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUE7O0FBQUEsY0FBQSxtQ0FBaUIsTUFBTSxDQUFDLGlCQUFQLE1BQU0sQ0FBQyxpQkFBa0I7OztFQUMxQyxjQUFjLENBQUMsUUFBUzs7OztFQUN4QixjQUFjLENBQUMsWUFBYTs7O0FBRTNCLG1CQUFvQixPQUFBLENBQVEsaUNBQVI7O0FBQ3JCLGNBQWMsQ0FBQyxTQUFVLENBQUEsbUNBQUEsQ0FBekIsR0FBZ0UsT0FBQSxDQUFRLHVDQUFSOztBQUVoRSxjQUFjLENBQUMsS0FBSyxDQUFDLGdCQUFyQixHQUF3QyxRQUFRLENBQUMsSUFBSSxDQUFDLE1BQWQsQ0FDdEM7RUFBQSxFQUFBLEVBQUksb0NBQUo7RUFDQSxRQUFBLEVBQVUsY0FBYyxDQUFDLFNBQVUsQ0FBQSxtQ0FBQSxDQURuQztFQUdBLFVBQUEsRUFBWSxTQUFBO1dBQ1YsSUFBQyxDQUFBLFFBQUQsQ0FBVSxJQUFDLENBQUEsVUFBWCxFQUF1QixlQUF2QixFQUF3QyxJQUFDLENBQUEsS0FBekM7RUFEVSxDQUhaO0VBTUEsS0FBQSxFQUFPLFNBQUE7SUFDTCxJQUFDLENBQUEsWUFBRCxDQUFBO1dBQ0EsSUFBQyxDQUFBLE1BQUQsQ0FBQTtFQUZLLENBTlA7RUFVQSxZQUFBLEVBQWMsU0FBQTtBQUNaLFFBQUE7SUFBQyxjQUFlLElBQUMsQ0FBQTtJQUNqQixNQUFtQixJQUFDLENBQUEsVUFBcEIsRUFBQyxlQUFELEVBQU87V0FDUCxJQUFDLENBQUEsTUFBRCxHQUFVLGdCQUFBLENBQWlCLElBQWpCLEVBQXVCLFdBQVcsQ0FBQyxLQUFuQyxFQUEwQyxRQUExQyxFQUFvRCxJQUFwRDtFQUhFLENBVmQ7RUFlQSxNQUFBLEVBQVEsU0FBQTtXQUNOLElBQUMsQ0FBQSxHQUFHLENBQUMsSUFBTCxDQUFVLElBQUMsQ0FBQSxRQUFRLENBQUMsTUFBVixDQUFpQjtNQUFBLGdCQUFBLEVBQWtCLElBQUMsQ0FBQSxNQUFuQjtLQUFqQixDQUFWO0VBRE0sQ0FmUjtDQURzQzs7QUFtQnhDLE1BQU0sQ0FBQyxPQUFQLEdBQWlCLGNBQWMsQ0FBQyxLQUFLLENBQUMifQ==
